import {handleErrorReq} from '@/helpers'

export default {
    name: 'forgot-password',
    data() {
        return {
            email: {
                val: '',
                error_msg: ''
            },
            success_msg: '',
            btn_submit_disabled: false
        }
    },
    methods: {
        submit() {
            this.btn_submit_disabled = true
            this.$store.dispatch('auth/forgotPass', { email: this.email.val })
                .then(res => {
                    this.btn_submit_disabled = false
                    this.email.error_msg = ''
                    let s_response = res.data.response
                    if(typeof s_response != 'undefined') {
                        if(s_response.toLowerCase() == 'success')
                            this.success_msg = 'Password sent to your email'

                        if(s_response.toLowerCase() == 'not_active') 
                            this.email.error_msg = 'This account has not been validated yet'
                    }
                },res => {
                    this.btn_submit_disabled = false
                    this.email.error_msg = ''
                    handleErrorReq(this, res)
                })
        },
        goToHome() {
            this.$parent.closeModal()
            this.$router.push({ name: 'home' })
        }
    },
    computed: {
        showDesktop() {
            return this.$root.$children[0].width > 1199
        }
    }
}